import { useView } from '../../hooks';
import { useWebhooks } from './useWebhooks';
import { formatDate } from '../../utilities';
import { useAppContext } from '../../shared';
import { Slug, Button } from '../../components';
import { Dropdown, Input, Table } from '../../components';
import { Form, FormItem, TopPanel } from '../../components';

const Webhooks = () => {
  const { meta } = useAppContext();
  const { element, handleView } = useView();
  const {
    nodes,
    refresh,
    filters,
    setFilters,
    intializing: loading,
    reloading,
  } = useWebhooks();

  return (
    <div className="flex flex-col gap-y-md w-full">
      {element}
      <TopPanel>
        <Form<NonNullable<typeof filters>>
          initialValue={filters}
          onChange={setFilters}
        >
          <FormItem<NonNullable<typeof filters>> name="campaignId" label="">
            <Dropdown
              placeholder="Campaign"
              grow={false}
              options={[
                { value: '', label: 'All Campaigns' },
                ...meta.campaigns,
              ]}
            />
          </FormItem>
          <FormItem<NonNullable<typeof filters>> name="eventType" label="">
            <Dropdown
              placeholder="Type"
              grow={false}
              options={[
                { value: '', label: 'All Types' },
                { value: 'email_received', label: 'Email Received' },
                { value: 'sms_received', label: 'SMS Received' },
                { value: 'phone_call', label: 'Phone Call' },
              ]}
            />
          </FormItem>
          <FormItem<NonNullable<typeof filters>> name="contactId" label="">
            <Input placeholder="Filter By Contact Email" />
          </FormItem>
        </Form>
        <Button icon="refresh" loading={reloading} onClick={refresh}>
          Refresh
        </Button>
      </TopPanel>
      <div className="flex-1 overflow-y-auto">
        <Table
          data={nodes}
          loading={loading}
          config={{
            columns: [
              {
                header: 'Type',
                cellClassName: 'max-w-[14rem]',
                getValue: ({ event_type }) => <Slug text={event_type} />,
              },
              {
                header: 'Contact',
                cellClassName: 'text-tiny max-w-[16rem]',
                getValue: ({ contact_id }) => contact_id,
                // getValue: ({ contact_id }) => contact_id.split('@')[0] || '-',
              },
              {
                header: 'Processed',
                cellClassName: 'max-w-[10rem]',
                getValue: ({ processed }) => (
                  <Slug
                    className="max-w-[5rem]"
                    text={processed ? 'true' : 'false'}
                    color={processed ? 'success' : 'warning'}
                  />
                ),
              },
              {
                header: 'Created',
                cellClassName: 'text-tiny max-w-[11.5rem]',
                cellContentClassName: 'max-w-[16.5rem]',
                getValue: ({ created_at }) => formatDate(created_at),
              },
              {
                header: 'Payload',
                align: 'right',
                getValue: ({ payload }) => (
                  <Button icon="eye" onClick={() => handleView(payload)}>
                    View
                  </Button>
                ),
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default Webhooks;
